import { setStringAsync } from 'expo-clipboard';

import type { ShareProps } from '@/shared/utils/share/shareProps';

export const share = async ({ message, url, note }: ShareProps) => {
  try {
    const clipboardMessage = `${message}\n${url}`;

    await setStringAsync(clipboardMessage);
    alert(`${note}\n\n${clipboardMessage}`);
  } catch (error) {
    console.error('Something went wrong while sharing a link', error);
  }
};
